module.exports = __webpack_public_path__ + "assets/img/3.d7a12997.png";